import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { AuthentService } from 'src/app/Services/authent.service';
import { FormularService } from 'src/app/Services/formular.service';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { TranslateTextPipe } from 'src/app/shared/pipes/translateText.pipe';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {
  innerHeading;
  innerText;

  constructor(
    private shareData: SharingDataService,
    private textTranslate: TranslateTextPipe,
    public formularService: FormularService,
    private authentService: AuthentService,
    ) { }

  ngOnInit(): void {
    this.shareData.currentLanguage.subscribe(data => {
      if(this.authentService.isLoggedIn()) this.getTexts(data)
    });
  }

  getTexts(language){
    var urls = [`admin/V_GIP_TEXT_T?$filter=LANG eq '${language}'`,]

    this.formularService.getData(urls, res => {
      this.innerHeading = this.textTranslate.transform("INFO", res[0], "TEXTID", "TEXT");
      this.innerText = this.textTranslate.transform("INFOHEAD", res[0], "TEXTID", "TEXT");
    })
  }

}
